import {Request} from 'common/domain/models/request';
import {AvailableDay} from 'common/domain/models/availableDayTypes';
import {EVENTS} from 'common/domain/constants';
import { parseLocalDate } from 'common/utils/dateUtils/date-utils';

class removePeriodController {
  constructor(EventEmitter,
              $scope,
              RemovePeriodService,
              $translate,
              AuthenticationService,
              vacationUserDataService,
              loadingMobileService) {
    'ngInject';
    this.scope = $scope;
    this.RemovePeriodService = RemovePeriodService;
    this.EventEmitter = EventEmitter;
    this.$translate = $translate;
    this.AuthenticationService = AuthenticationService;
    this.vacationUserDataService = vacationUserDataService;
    this.loadingMobileService = loadingMobileService;
    this.userId = this.AuthenticationService.getEmployeeId();
    this.errors = [];

    this
      .scope
      .$on(EVENTS.CONTEXT_MENU_REMOVE, (event, args) => {
        this.setData(args.dayClicked, args.dateDayClicked, args.period);
      });

    this
      .$translate('VACATIONS_ABSENCES.VALIDATION_ERRORS.REMOVE_REASON_MAX_LENGTH')
      .then((translation) => {
        this.errors.push(translation);
      });
  }

  $onInit() {
    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
    }
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.REMOVE'
      },
      {
        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
      }
    ];
  }

  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  setData(dayClicked, dateDayClicked, period) {
    this.startDate = parseLocalDate(period.startDate);
    this.endDate = period.endDate === null ? null : parseLocalDate(period.endDate);
  
    this.type = Request.getTranslation(period.type);
    this.availableDayType = AvailableDay.getTranslation(period.availableDayType);
    this.category = period.category;
    this.code = period.code;
    this.numberDays = period.maximumDuration;
  
    if (Request.isHourly(period)) {
      this.isHourly = true;
      this.hours = period.hours;
    } else {
      this.isHourly = false;
      delete this.hours;
    }
  }

  getRequest() {
    const startDate = this.startDate;
    const endDate = this.endDate;
    const periodCode = this.code;
    return {startDate, endDate, periodCode};
  }

  submit() {
    this.loadingMobileService.show();

    const request = this.getRequest();
    const managerId = this.vacationUserDataService._employee.userId;
    const userId = this.userInceptionId || this.userId;
    this
      .RemovePeriodService
      .removeRequest(userId, request, this.isInception, managerId)
      .then((response) => {
        const $event = this.EventEmitter({ status: response.status, startDate: request.startDate, endDate: request.endDate });
        this.onRemove($event);
      }, response => {
        this.onError(this.EventEmitter(response));
      })
      .finally(() => this.loadingMobileService.hide());
  }

  onCancel() {
    $('.modal').modal('hide');
  }
}

export default removePeriodController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRemovePeriod/removePeriod/removePeriod.controller.js